export const TEXT = {
    PageTitle: { en: "Database Management", ar: "إدارة قاعدة البيانات" },
    CreateDbGroup: { en: "Create DB Group", ar: "إنشاء مجموعة قاعدة البيانات" },
    CreateDB: { en: "Create Database", ar: "إنشاء قاعدة بيانات" },
    DbBrowser: { en: "Browse Databases", ar: "تصفح قواعد البيانات" },
    EditDbGroup: { en: "Edit DB Group", ar: "تحرير مجموعة قاعدة البيانات" },
    ExportData: { en: "Export Data", ar: "تصدير البيانات" },
    ExportDataDesc: { en: "Export all database data to JSON", ar: "تصدير جميع بيانات قاعدة البيانات إلى JSON" },
    ImportData: { en: "Import Data", ar: "استيراد البيانات" },
    ImportDataDesc: { en: "Import data from JSON backup", ar: "استيراد البيانات من نسخة احتياطية JSON" },
    DatabaseInfo: { en: "Database Info", ar: "معلومات قاعدة البيانات" },
    DatabaseInfoDesc: { en: "View detailed database information", ar: "عرض معلومات مفصلة عن قاعدة البيانات" },
    ClearData: { en: "Clear Data", ar: "مسح البيانات" },
    ClearDataDesc: { en: "Remove all database data", ar: "إزالة جميع بيانات قاعدة البيانات" },
    Export: { en: "Export", ar: "تصدير" },
    Import: { en: "Import", ar: "استيراد" },
    ViewInfo: { en: "View Info", ar: "عرض المعلومات" },
    Clear: { en: "Clear All", ar: "مسح الكل" },
    DbGroups: { en: "Database Groups", ar: "مجموعات قاعدة البيانات" },
    NoDbGroups: { en: "No Database Groups found", ar: "لم يتم العثور على مجموعات قاعدة البيانات" },
    Databases: { en: "Databases", ar: "قواعد البيانات" },
    NoDatabases: { en: "No Databases found", ar: "لم يتم العثور على قواعد بيانات" },
    ConfirmDelete: { en: "Confirm Delete", ar: "تأكيد الحذف" },
    ConfirmDeleteAll: { en: "Are you sure you want to delete ALL data? This action cannot be undone.", ar: "هل أنت متأكد من حذف جميع البيانات؟ لا يمكن التراجع عن هذا الإجراء." },
    ConfirmDeleteItem: { en: "Are you sure you want to delete", ar: "هل أنت متأكد من حذف" },
    Cancel: { en: "Cancel", ar: "إلغاء" },
    Delete: { en: "Delete", ar: "حذف" },
    DatabaseName: { en: "Database Name", ar: "اسم قاعدة البيانات" },
    Version: { en: "Version", ar: "الإصدار" },
    ObjectStores: { en: "Object Stores", ar: "مخازن الكائنات" },
    TotalDbGroups: { en: "Total Database Groups", ar: "إجمالي مجموعات قاعدة البيانات" },
    TotalDatabases: { en: "Total Databases", ar: "إجمالي قواعد البيانات" },
    Close: { en: "Close", ar: "إغلاق" },
    ExportConfirm: { en: "This will export all database groups and databases to a JSON file.", ar: "سيتم تصدير جميع مجموعات قاعدة البيانات وقواعد البيانات إلى ملف JSON." },
    ExportInfo: { en: "Export includes:", ar: "يتضمن التصدير:" },
    ImportConfirm: { en: "Select a JSON file to import data.", ar: "حدد ملف JSON لاستيراد البيانات." },
    ImportWarning: { en: "Warning: Importing data will merge with existing data. Conflicts may occur with duplicate IDs.", ar: "تحذير: سيتم دمج البيانات المستوردة مع البيانات الموجودة. قد تحدث تعارضات مع المعرفات المكررة." }
};

export default TEXT;